const nodeEnv = require('node-env.js')
export const environment = {
    production: true,
    ENVNAME: 'PRODUCTION',
    DISABLE_CONSOLE: true,
    API_BASE_URL: "https://api.realworld.fi/api/v1",
    API_BASE_URL_V2: "https://api.realworld.fi/api/v2/market-place",
    API_BASE_URL_V3: "https://api.realworld.fi/api/v3/market-place",
    SOCKET_BASE_URL: "https://api.realworld.fi:3050",
    WEB_SITE_URL: 'https://app.realworld.fi/',
    FILE_UPLOAD: "https://api.realworld.fi/api/v3",
    GOOGLE_ANALYTICS_KEY: nodeEnv.GOOGLE_ANALYTICS_KEY,
    '0x89': {
        EXPLORER: 'https://polygonscan.com',
        PROVIDER: 'https://polygon-mainnet.infura.io/v3/dd42eb8e92fb4f55b21dc1070bb1d997',
        CHAIN_NETWORK: '0x89',
        CHAINID: 137,
        CURRENCY_NAME: 'MATIC',
        CURRENCY_SYMBOL: 'MATIC',
        CHAIN_NAME: 'Polygon',
        FACTORY_ADDRESS: '0xDBadEf1e8e2aF02308d062E194C03c3255190479',
        ACCESS_CONTROL_CONTRACT: '0x5187B42146E5Ee52b5C4e69FFa0512087C124bBd',
        BORROW_LEND_CONTRACT: '0x52B8fBD5828900E6D73dF06C0c1dC509D4080e0D',
        EXCHANGE_CONTRACT: '0xbF5b75cf44B6BB9A6afC9F48D548CA5F986b423d',
        LOAN_IN_DAYS: true
    },
    WALLET_CONNECT_PROJECT_ID: "1d4239b8e2f61deb31b0d6b21cc466fd", // this key get from client
    COINGECKO_API: "https://api.coingecko.com/api/v3/simple",
    COINGECKO_API_KEY: "CG-AJA371ALNy6Y2xapoaotHsTM",
    DEFAULT_NETWORK: '137',
    DEFAULT_CHAIN: '0x89',
    PINATA_KEY: '3816585697981d38d50d',
    PINATA_SECRET: '4722d4967331aafb013d9dab2bc6e3534e654be9a1cbc8ce4aa4adaec3c13f27',
    PINATA_BASE_URL: 'https://chocolate-magnificent-blackbird-410.mypinata.cloud/ipfs/',
    GOOGLE_LOGIN_PROVIDER: '398286696618-p0aem6s2cghcp62g4hgvkd7offm7ota4.apps.googleusercontent.com',
    // production idenfy key
    IDENFY_API_KEY: 'NfnARmPQV1w',//Realworld Finance (Ltv) - PROD
    IDENFY_API_SECRET: 'grODOgFwPP4Nmg9upr3G',
    API_KEY:'e08759ed-5d5e-486d-9121-502034c9abf6',
    TRANSACTION_LINK:'https://global.transak.com/?apiKey',

    // Gold category ENVs
    ONE_OUNCE: "28.35g",
    TEN_TOLA_BAR: "116.64g",
    ONE_KILO_GRAM: "1000g",
    // Idle
    AUTO_LOGOUT_DURATION: 86400, // (24 hours) In seconds; how long for inactive modal to appear
    AUTO_LOGOUT_TIMEOUT: 30, // In seconds; how long for user to act after inactive modal appears before being logged out.
};
